import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Row, Form, Button } from 'react-bootstrap';
import { InforAlert, TimerAlert } from "../../utils/swtAlert";
import { Authentication } from '../../utils/axios/Auth';
import { Decrypt, Encrypt, GetSignedInUserInfo } from "../../utils/Helper";
import { GrokLoading } from '../page-layout/loading/Loading';
import { FetchLookups } from '../constants/constants';
import jwt from 'jwt-decode';

function Login() {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);

    const location = useLocation().search;
    const isFromGrok = new URLSearchParams(location).get('from-grok');
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            handleLogin();
        }
    };

    const handleLogin = async () => {
        let authPayload = {
            Email: email,
            Password: password
        }
        setLoading(true);
        var authenticate = await Authentication(authPayload);
        setLoading(false);
        if (authenticate.success) {
            TimerAlert("You'll be redirected to change password", "Now create your password", 'success');
            sessionStorage.setItem('Email', Encrypt(authenticate.userIdAndEmail.Email));
            sessionStorage.setItem('UserId', Encrypt(authenticate.userIdAndEmail.Id));
            navigate('/changepassword');
        }
        else if (authenticate.response.data === "User Organization not found") {
            TimerAlert("Access Denied!", "User Organization not found", "error")
        }
        else if (authenticate.response.data === "Access Denied") {
            TimerAlert("Access Denied", "Please contact grok admin", "info");
        }
        else if (authenticate.response.data === "Invalid Credentials or User is Disabled") {
            TimerAlert("Invalid Credentials", "Please try again...", "error");
        }
        else if (authenticate.response.data === "All challenge registrations have expired. Please register new challenges to activate.") {
            InforAlert("All challenge registrations have expired. Please register new challenges to Activate.", "No Active Challenges!", "error", "Ok");
        }
        else if (authenticate.response.status === 200) {
            let decoded = jwt(authenticate.data.token);
            sessionStorage.setItem('token', Encrypt(authenticate.data.token));
            sessionStorage.setItem('userInfo', Encrypt(JSON.stringify(GetSignedInUserInfo())));
            const close = localStorage.getItem('close');
            localStorage.setItem('theme', close)

            localStorage.setItem('user', Encrypt(email));
            localStorage.setItem('pwd', Encrypt(password));
            await FetchLookups();
            if (decoded.result.IsAgreementSigned) {
                navigate('/home');
            }
            else {
                navigate('/terms');
            }
        }
    };

    const autoLogin = async () => {
        let email = Decrypt(localStorage.getItem('user'));
        let password = Decrypt(localStorage.getItem('pwd'));
        if (email && password) {
            let authPayload = {
                Email: email,
                Password: password
            }
            var authenticate = await Authentication(authPayload);
            if (authenticate.response.status === 200) {
                localStorage.setItem('user', Encrypt(email));
                localStorage.setItem('pwd', Encrypt(password));
                sessionStorage.setItem('token', Encrypt(authenticate.data.token));
                sessionStorage.setItem('userInfo', Encrypt(JSON.stringify(GetSignedInUserInfo())));
                await FetchLookups();
                navigate('/home');
            }
            else {
                TimerAlert('Try logging in again...', 'Oops Something Went Wrong', 'error');
            }
        }
    }
    useEffect(() => {
        if (isFromGrok) {
            autoLogin();
        }
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userInfo');
        sessionStorage.removeItem('userDetails');
    }, [])

    return (
        <div className="rootmain border-top-wide border-primary d-flex flex-column theme-light">
            {loading ? <GrokLoading /> : ""}
            {!isFromGrok && <div className='page page-center'>
                <div className='container-tight py-4'>
                    <div className='text-center mb-4'>
                        {/* <a href="#" className='navbar-brand navbar-brand-autodark'>
                            <img src={require('../../images/grok pvt ltd logo.png')} className='img-fluid' width={200} />
                        </a> */}
                        <h1 className="navbar-brand navbar-brand-autodark">
                            <div className='light-logo'>
                                <Link>
                                    <img src={require('../../images/grok pvt ltd logo.png')} width="50" height="32" alt="Logo" className="img-fluid navbar-brand-image" />
                                </Link>
                            </div>
                            <div className='dark-logo'>
                                <Link>
                                    <img src={require('../../images/grok pvt ltd logo_dark.png')} width="50" height="32" alt="Logo" className="img-fluid navbar-brand-image" />
                                </Link>
                            </div>
                        </h1>
                    </div>
                    <Form className='card card-md' noValidate validated={validated} onSubmit={handleSubmit}>
                        <div className='card-body'>
                            <h3 className='card-title text-center mb-2'>Login</h3><hr />
                            <Row className="mb-2">
                                <Form.Group className="mb-2" controlId="formBasicEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                    <Form.Control.Feedback type="invalid"> Email is required</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-2" controlId="formBasicPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                    <Form.Control.Feedback type="invalid">Password is required</Form.Control.Feedback>
                                    <Link className='form-label-description mt-2' to='/forgotpassword'>Forgot password ?</Link>
                                    {/* <Link className='form-label-description mt-2'>Forgot password ?</Link> */}
                                </Form.Group>
                            </Row>
                            <Row className="mb-2">
                                <Form.Group className="login-btn mb-3">
                                    <Button className="btn btn-primary" type='submit' style={{ width: "100%", backgroundColor: "#ff0080" }}> Login</Button>
                                </Form.Group>
                            </Row>
                        </div>

                    </Form>
                </div>
            </div>}
        </div>
    );
}

export default Login;